// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/sass/app.scss
// module id = 279
// module chunks = 0